import React from 'react'
import Input from './Input'

const SPAN_STYLE = {
    paddingTop: '5px',
    paddingBottom: '0px',
    cursor: 'pointer',
}

const ICON_STYLE = {
    fontSize: '18px',
}

class Password extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            hidePassword: true,
        }
        this.togglePassword = this.togglePassword.bind(this)
    }

    togglePassword () {
        this.setState({
            hidePassword: !this.state.hidePassword,
        })
    }

    render () {
        let icon = 'icon-eye'
        let type = 'password'
        if (!this.state.hidePassword) {
            icon = 'icon-eye-slash'
            type = 'text'
        }
        return (
            <div className="input-group">
                <Input {...this.props} type={type} className="form-control" autocapitalize="Off"/>
                <span className="input-group-addon" style={SPAN_STYLE} onClick={this.togglePassword}>
                    <i className={icon} style={ICON_STYLE}/>
                </span>
            </div>
        )
    }
}


Password.propTypes = {}

export default Password



// WEBPACK FOOTER //
// ./src/modules/form/component/Password.js